import { PropsWithChildren } from "react";
import { CSSProperties } from "styled-components";
import { ReactComponent as Close } from "../../../assets/svg/close.svg";
import { getOptionsTypeFromSymbol } from "../../../utils/instruments";
import { BaseModal } from "../../BaseModal";
import { Button, ButtonThemeEnum } from "../../Buttons/styles";
import MarketHeader from "./MarketHeader";
import { TitleContainer } from "./style";

type IBaseDetailsModalProps = PropsWithChildren & {
  show: boolean;
  onHide?: () => void;
  style?: any; //CSSProperties;

  instrument?: {
    instrument_name: string;
    /** The market's vertical (spot / perpetual / option). */
    instrument_type?: string;
    expiry?: string;
    strike?: string;

    /** Absent, null or 0 renders "-": an unknown mark is never "$0.00". */
    markPrice?: string | null;
    markIncreasePercent?: number;
  };
};

function BaseDetailsModal({
  show,
  onHide,
  children,
  instrument,
  style,
}: IBaseDetailsModalProps) {
  return (
    <BaseModal
      hideCloseButton
      show={show}
      onHide={onHide}
      style={{
        ...style,
        minWidth: 311,
      }}
    >
      {instrument && (
        <TitleContainer>
          <MarketHeader
            instrumentName={instrument.instrument_name}
            instrumentType={instrument.instrument_type}
            optionType={getOptionsTypeFromSymbol(instrument.instrument_name)}
            expiry={instrument.expiry}
            strike={instrument.strike}
            price={instrument.markPrice}
            priceIncreasePercent={instrument.markIncreasePercent}
          />
          <Button
            style={{
              height: "56px",
              width: "56px",
            }}
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            onClick={onHide}
          >
            <Close />
          </Button>
        </TitleContainer>
      )}
      {children}
    </BaseModal>
  );
}

export default BaseDetailsModal;
